@if (!isCustom) {
  <i-feather [name]="name" [class]="iconClass"></i-feather>
}
@if (isCustom) {
  <img alt="" [class]="iconClass" src="./assets/img/icons/{{ name }}.svg" />
}
